import { implementService } from '@wix/services-manager/helpers'
import { Signal, SignalsServiceDefinition } from '@wix/services-manager/core-services/signals'
import type { ServiceFactoryOpts } from '@wix/services-manager/types'
import { INamedSignalsServiceConfig, NamedSignalsServiceDefinition } from '../definitions'

export const NamedSignalsService = implementService(
	NamedSignalsServiceDefinition,
	({ config, getService }: ServiceFactoryOpts<INamedSignalsServiceConfig>) => {
		const signalRegistry: Record<string, Signal<any>> = {}
		const signalsService = getService(SignalsServiceDefinition)

		// set initial state if exists
		config.initialStore?.forEach(
			(value: any, name: string) => (signalRegistry[name] = signalsService.signal(value))
		)

		void config.onRemoteChange((remoteName, remoteValue) => {
			const signal = signalRegistry[remoteName]
			if (!signal) {
				return
			}
			signal.set(remoteValue)
		})

		return {
			...signalsService,
			signal: (initialValue: any, name: string) => {
				const signal = signalsService.signal(initialValue)
				signalRegistry[name] = signal

				return {
					...signal,
					set: (value: any) => {
						signal.set(value)
						void config.updateRemote(name, value)
					},
				}
			},
		}
	}
)
